// Subcategories API - Updated for new hierarchy
import api from './api';

export const subcategoriesAPI = {
  // Get all subcategories
  getAll: (params = {}) => {
    const searchParams = new URLSearchParams();
    if (params.is_active !== undefined) {
      searchParams.append('is_active', params.is_active);
    }
    if (params.category_id) {
      searchParams.append('category_id', params.category_id);
    }
    if (params.search) {
      searchParams.append('search', params.search);
    }
    if (params.page) {
      searchParams.append('page', params.page);
    }
    if (params.limit) {
      searchParams.append('limit', params.limit);
    }
    
    const url = searchParams.toString() ? `/subcategories?${searchParams}` : '/subcategories';
    return api.get(url);
  },

  // Get subcategories by product group UUID (NEW HIERARCHY ENDPOINT)
  getByProductGroup: (productGroupUuid) => {
    return api.get(`/subcategories/by-product-group/${productGroupUuid}`);
  },

  // Get single subcategory
  getById: (uuid) => {
    return api.get(`/subcategories/${uuid}`);
  },

  // Create subcategory (now requires product_group_uuid)
  create: (formData) => {
    return api.post('/subcategories', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // Update subcategory (now requires product_group_uuid)
  update: (uuid, formData) => {
    return api.put(`/subcategories/${uuid}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // Delete subcategory
  delete: (uuid, force = false) => {
    return api.delete(`/subcategories/${uuid}${force ? '?force=true' : ''}`);
  },

  // Force delete subcategory
  forceDelete: (uuid) => {
    return api.delete(`/subcategories/${uuid}?force=true`);
  },

  // Toggle subcategory status
  toggleStatus: (uuid) => {
    return api.patch(`/subcategories/${uuid}/toggle-status`);
  },
};